import { InlineIcon } from "@iconify/react-with-api";
import clsx from "clsx";
import React from "react";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Search: React.FC<InputProps> = (props) => {
  const { onChange, className, value, defaultValue, ...other } = props;

  return (
    <div className={`search-wrapper`}>
      <InlineIcon icon="mdi:magnify" />
      <input
        className={clsx(`input`, className)}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        {...other}
      />
    </div>
  );
};
